/* eslint-disable  @typescript-eslint/no-explicit-any */
import { Module } from 'vuex'

const customization: Module<any, any> = {
    state: {
        showFixMeBanner: true,
    },

    getters: {
        showFixMeBanner: (state: any) => state.showFixMeBanner,
    },

    actions: {
        async UpdateFixMeBanner({ commit }, { show }) {
            commit('setShowFixMeBanner', show)
        },
    },

    mutations: {
        setShowFixMeBanner(state: any, show: boolean) {
            state.showFixMeBanner = show
        },
         clearCustomization(state, _) {
            state.showFixMeBanner = true
        }
    },
}

export default customization